import { render, staticRenderFns } from "./TakeAssignment.vue?vue&type=template&id=4ccccbd2&scoped=true"
import script from "./TakeAssignment.vue?vue&type=script&lang=js"
export * from "./TakeAssignment.vue?vue&type=script&lang=js"
import style0 from "./TakeAssignment.vue?vue&type=style&index=0&id=4ccccbd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccccbd2",
  null
  
)

export default component.exports